// React imports
import React from 'react';

// React Router imports
import { Link } from 'react-router-dom';

// Redux imports
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

// Asset imports (images and icons)
import Navbar from '../../assets/navbar.png';
import Person from '../../assets/person.png';
import { ReactComponent as BuiltLogo } from '../../assets/built-logo.svg';

// Component imports
import Button from './Button';

interface MobileHeaderProps {
  isAuthenticated: boolean;
  onMenuClick?: () => void;
  userId?: number;
  navigate: (path: string) => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  isAuthenticated,
  onMenuClick,
  navigate,
}) => {
  const user = useSelector((state: RootState) => state.user);

  return (
    <div
      className={`d-flex w-100 align-items-center p-3 ${
        isAuthenticated ? 'justify-content-between' : 'justify-content-center'
      }`}
    >
      {isAuthenticated && (
        <Button
          type="button"
          className="person-button"
          onClick={onMenuClick}
          aria-label="Open navigation drawer"
        >
          <img src={Navbar} alt="navbar" className="navbar-logo" />
        </Button>
      )}
      <div className="sign-in-logo">
        <Link to={isAuthenticated ? '/dashboard' : '/'}>
          <BuiltLogo fill="white" />
        </Link>
      </div>
      {isAuthenticated && (
        <Button
          type="button"
          className="person-button"
          onClick={() => navigate(`/profile/${user.userDetails?.userId}`)}
          aria-label="Open profile menu"
        >
          <img src={Person} alt="person" className="person-logo" />
        </Button>
      )}
    </div>
  );
};

export default MobileHeader;
